import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Display, Meta, Rule, Chip } from '../components/Atoms';

/**
 * Help - centrum pomocy / FAQ.
 *
 * Publiczny ekran (/pomoc). Bez auth.
 * Sekcje: pierwsze kroki, główne funkcje, FAQ, skróty klawiszowe, kontakt.
 */

const FAQ = [
  {
    q: 'Czy aplikacja jest darmowa?',
    a: 'Tak, w pełni darmowa — bez ukrytych opłat, bez wersji premium, bez reklam. Jeśli ktoś chce wesprzeć projekt, najlepiej powiedzieć znajomym ogrodnikom.',
  },
  {
    q: 'Czy moje dane są bezpieczne?',
    a: 'Tak. Hasła są hashowane (bcrypt), tokeny w httpOnly cookies (chronione przed XSS), całość pod HTTPS. Nie sprzedajemy danych, nie używamy cookies śledzących. Pełna polityka: /privacy-policy.',
  },
  {
    q: 'Jak dodać nową roślinę do mojej działki?',
    a: 'Wejdź w Działki → wybierz konkretną → kliknij "+ Grządka". Wybierz roślinę z bazy ponad 1000 gotowych roślin albo dodaj własną. Twoja roślina pojawi się w katalogu jako kandydatka do moderacji.',
  },
  {
    q: 'Co to jest karencja oprysku?',
    a: 'Liczba dni od oprysku, podczas których nie wolno zbierać plonów (substancja czynna jeszcze działa). Aplikacja wyznacza datę bezpiecznego zbioru automatycznie i ostrzega na liście oprysków oraz zadań.',
  },
  {
    q: 'Czy mogę używać aplikacji bez internetu?',
    a: 'Częściowo — dzięki PWA aplikacja zapamiętuje statyczny interfejs, ale nowe dane (zadania, zdjęcia, statystyki) wymagają połączenia. Pełny tryb offline jest na liście planów.',
  },
  {
    q: 'Jak zainstalować aplikację na telefonie?',
    a: 'Otwórz gardenapp.pl w przeglądarce mobilnej i wybierz "Dodaj do ekranu głównego" (Android: menu Chrome, iOS: udostępnij → ekran początkowy). Aplikacja zacznie wyglądać jak natywna.',
  },
  {
    q: 'Czy mogę pokazać swój ogród znajomym?',
    a: 'Tak — w Profil → Profil publiczny włącz widoczność, wybierz nazwę użytkownika i podziel się linkiem gardenapp.pl/g/twoja-nazwa. Goście nie muszą się rejestrować.',
  },
  {
    q: 'Jak działają znajomi w aplikacji?',
    a: 'Włącz profil publiczny, a potem w Społeczność → Znajomi wyszukaj innych ogrodników i wyślij zaproszenie. Znajomość zaczyna działać dopiero po akceptacji — obie strony muszą się zgodzić. Znajomi widzą nawzajem swoją aktywność (zbiory, zdjęcia, osiągnięcia) w zakładce Aktywność, a jeśli to włączysz — mogą też podejrzeć Twój ogród. W każdej chwili możesz kogoś usunąć lub zablokować.',
  },
  {
    q: 'Czym jest giełda roślin?',
    a: 'To wymiana między znajomymi: nadmiar rozsady, nasion czy plonów wystawiasz jako „oddam", „wymienię" albo „sprzedam". Ogłoszenia widzą tylko Twoi znajomi. Zainteresowani piszą przez wbudowane wiadomości — bez podawania numeru telefonu ani adresu.',
  },
  {
    q: 'Coś zaatakowało moją roślinę — co robić?',
    a: 'Masz dwie drogi. Katalog chorób i szkodników (Menu → Choroby i szkodniki) pomoże rozpoznać problem po objawach. Możesz też zapytać znajomych: przy zdjęciu w galerii wybierz „Zapytaj znajomych", a pytanie trafi do ich Aktywności — odpowiedzą w komentarzach.',
  },
  {
    q: 'Jak włączyć powiadomienia na telefonie?',
    a: 'Najpierw zainstaluj aplikację na ekranie głównym (patrz pytanie o instalację), a potem włącz powiadomienia w ustawieniach konta. Dostaniesz je m.in. przy alertach mrozowych, po upływie karencji oprysku i przy aktywności znajomych. Powiadomieniami mailowymi sterujesz w tym samym miejscu.',
  },
  {
    q: 'Jak usunąć konto?',
    a: 'Profil → Konto → Strefa niebezpieczna → "Usuń moje konto". Wymaga hasła + wpisania słowa USUWAM. Konto zostaje skasowane miękko (soft delete) — masz 30 dni na cofnięcie z linku w mailu, potem dane są usuwane bezpowrotnie.',
  },
  {
    q: 'W jakich formatach mogę wyeksportować dane?',
    a: 'JSON i CSV dla działek, oprysków oraz pełnego backupu. Kalendarz zadań w formacie iCal (.ics) — można otworzyć w Google Calendar, Apple Calendar, Outlook itp. Dostępne w Eksport.',
  },
  {
    q: 'Jak działa alert mrozowy?',
    a: 'Aplikacja monitoruje prognozę pogody dla Twojej lokalizacji. Gdy prognozowana minimalna temperatura spadnie poniżej +2°C, dostaniesz email z listą wrażliwych roślin do okrycia. Wymaga ustawienia miasta i strefy w Profil → Mój ogród.',
  },
  {
    q: 'Jak prowadzić zapasy nasion?',
    a: 'Menu → Magazyn nasion. Dodajesz każdą torebkę: roślina, odmiana, rok pozyskania, ilość i skąd (sklep / wymiana / własne zbiory). Przy nasionach starszych niż 3 lata pojawia się ostrzeżenie „może tracić siłę kiełkowania" — najczęściej warto je wtedy sprawdzić przed siewem albo wymienić. Zimą to wygodny sposób, żeby zaplanować sezon na podstawie tego, co już masz.',
  },
  {
    q: 'Do czego służą „Moje odmiany"?',
    a: 'Menu → Moje odmiany. Po zbiorze oceniasz odmianę w trzech skalach 1–5 (plon, smak, odporność) i dopisujesz notatkę. Twoje oceny pojawiają się potem na karcie danej rośliny w sekcji „Sprawdzone u mnie" — dzięki temu przy planowaniu widzisz, co naprawdę sprawdziło się u Ciebie (np. „2025: Malinowy Ożarowski — plon 5/5"). Z każdym sezonem ta baza jest cenniejsza.',
  },
  {
    q: 'Jak śledzić rozsadę z parapetu?',
    a: 'Menu → Rozsada. Każdy wysiew prowadzisz przez cztery etapy: Wysiew → Pikowanie → Hartowanie → Wysadzenie. Przyciskiem „Przenieś dalej" przesuwasz partię do kolejnego etapu, a ekran grupuje wszystko wg etapu — od razu widać, co czeka na pikowanie, a co na wysadzenie do gruntu.',
  },
  {
    q: 'Skąd wiem, że nie muszę podlewać?',
    a: 'Na ekranie Dziś aplikacja bierze pod uwagę opady z prognozy dla Twojej lokalizacji. Jeśli niedawno padało lub deszcz jest zapowiadany, zobaczysz podpowiedź „nie podlewaj". Wymaga ustawionej lokalizacji (Profil → Mój ogród).',
  },
  {
    q: 'Czy dostanę przypomnienie o wysiewie?',
    a: 'Tak — jeśli masz włączone powiadomienia. Raz w miesiącu aplikacja sprawdza rośliny z Twoich grządek i planów sezonu i przypomni, gdy okno wysiewu którejś kończy się w danym miesiącu („zdąż zasiać"). Nie zaśmieca — to jedno powiadomienie na miesiąc.',
  },
  {
    q: 'Jak włączyć jasny motyw?',
    a: 'Menu → Narzędzia i ustawienia → „Tryb jasny". Papierowy, jasny motyw jest czytelniejszy na działce w pełnym słońcu. Wybór jest zapamiętywany, a ciemny motyw wracasz tym samym przełącznikiem.',
  },
];

const FEATURES = [
  {
    title: 'Działki i grządki',
    desc: 'Mapa wizualna każdej działki, z grządkami w rzędach. Każda grządka ma swoją historię — sadzenie, podlewanie, opryski, zbiory.',
  },
  {
    title: 'Katalog ponad 1000 roślin',
    desc: 'Każda roślina ma stronę z opisem, zdjęciem, terminem siewu, czasem do zbioru, kompozycją uprawową.',
  },
  {
    title: 'Zadania i przypomnienia',
    desc: 'Lista do zrobienia z filtrami "dziś / nadchodzące / spóźnione". Cykliczne (np. podlej co 2 dni) generują się automatycznie.',
  },
  {
    title: 'Pielęgnacja zaawansowana',
    desc: 'Opryski z karencją, harmonogram nawożenia, kalendarz kwitnienia, ochrona zimowa, dzielenie bylin, deadheading.',
  },
  {
    title: 'Pogoda i strefa',
    desc: 'Aktualna pogoda na ekranie głównym, alert mrozowy mailem, dopasowanie sugestii sadzenia do strefy mrozoodporności.',
  },
  {
    title: 'Plany sezonu',
    desc: 'Rozpisz co posadzisz wiosną. Plan można potem przekonwertować w zadania albo zrealizować jako prawdziwe grządki.',
  },
  {
    title: 'Magazyn nasion',
    desc: 'Inwentarz Twoich nasion — odmiana, rok, ilość i źródło. Ostrzeżenie o starzejących się nasionach (siła kiełkowania). Najbardziej przydaje się zimą przy planowaniu.',
  },
  {
    title: 'Moje odmiany',
    desc: 'Oceniaj odmiany po zbiorze (plon / smak / odporność 1–5). Oceny „sprawdzone u mnie" wracają na karcie rośliny i podpowiadają, co warto posadzić ponownie.',
  },
  {
    title: 'Rozsada',
    desc: 'Prowadź wysiew z parapetu przez etapy: wysiew → pikowanie → hartowanie → wysadzenie. Widzisz na jednym ekranie, co czeka na kolejny krok.',
  },
  {
    title: 'Woda i terminy',
    desc: 'Podpowiedź „nie podlewaj", gdy padało lub będzie padać, oraz miesięczne przypomnienie, gdy zamyka się okno wysiewu roślin z Twoich grządek i planów.',
  },
  {
    title: 'Społeczność',
    desc: 'Znajomi, wspólna aktywność, giełda roślin i pytania do innych ogrodników. Wszystko za obopólną zgodą — Ty decydujesz, kto co widzi.',
  },
];

const SHORTCUTS = [
  { keys: 'Ctrl + K', desc: 'Otwórz wyszukiwanie globalne' },
  { keys: '⌘ + K', desc: 'Otwórz wyszukiwanie (macOS)' },
  { keys: 'Esc', desc: 'Zamknij aktywny dialog / overlay' },
];

function FaqItem({ q, a, open, onToggle }) {
  return (
    <div style={{
      borderBottom: '1px solid var(--t-line)',
    }}>
      <button
        type="button"
        onClick={onToggle}
        style={{
          width: '100%', textAlign: 'left',
          padding: '18px 0',
          background: 'transparent', border: 'none', cursor: 'pointer',
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
          gap: 14,
        }}
      >
        <span style={{
          fontFamily: 'var(--t-display)', fontSize: 17,
          color: 'var(--t-text)', letterSpacing: '-.01em',
          lineHeight: 1.35, flex: 1,
        }}>{q}</span>
        <span style={{
          fontFamily: 'var(--t-mono)', fontSize: 18,
          color: open ? 'var(--t-sage)' : 'var(--t-text-mute)',
          flexShrink: 0, lineHeight: 1,
          transition: 'transform 200ms ease',
          transform: open ? 'rotate(45deg)' : 'rotate(0)',
        }}>+</span>
      </button>
      {open && (
        <div style={{
          padding: '0 0 22px',
          fontSize: 14, color: 'var(--t-text-dim)',
          lineHeight: 1.65,
        }}>{a}</div>
      )}
    </div>
  );
}

export default function Help() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="redesign-root" style={{
      minHeight: 'var(--t-vh)',
      background: 'var(--t-bg)',
      color: 'var(--t-text)',
      fontFamily: 'var(--t-sans)',
    }}>
      <div style={{
        maxWidth: 760, margin: '0 auto',
        padding: '60px 32px 80px',
      }}>
        <Link to="/" style={{
          fontFamily: 'var(--t-mono)', fontSize: 11,
          letterSpacing: '.18em', textTransform: 'uppercase',
          color: 'var(--t-sage)', textDecoration: 'none',
          marginBottom: 30, display: 'inline-block',
        }}>← Strona główna</Link>

        <Meta color="sage" style={{ marginBottom: 12 }}>Centrum pomocy</Meta>
        <Display size={'clamp(48px, 8vw, 72px)'} style={{
          display: 'block', letterSpacing: '-.04em', lineHeight: 0.95,
          marginBottom: 18,
        }}>Jak korzystać z GardenApp.pl</Display>
        <div style={{
          fontSize: 16, color: 'var(--t-text-dim)',
          lineHeight: 1.55, marginBottom: 50, maxWidth: 580,
        }}>
          Krótkie wprowadzenie, najczęstsze pytania i informacje kontaktowe.
          Aplikacja jest darmowa i otwarta — chętnie pomożemy.
        </div>

        <Rule label="I — pierwsze kroki" />
        <div style={{ marginBottom: 50 }}>
          <ol style={{
            padding: 0, margin: 0, listStyle: 'none',
            counterReset: 'step',
          }}>
            {[
              { t: 'Załóż konto', d: 'Rejestracja prosi tylko o nazwę, email i hasło. Aktywacja przez link mailowy.' },
              { t: 'Uzupełnij ogród', d: 'Profil → Mój ogród → wpisz miasto, strefę mrozoodporności, daty przymrozków. To zwiększa trafność sugestii.' },
              { t: 'Dodaj pierwszą działkę', d: 'Działki → "+ Działka" → nazwa i opis (możesz dodać zdjęcie). Wewnątrz utwórz grządki i przypisz im rośliny z katalogu.' },
              { t: 'Zaplanuj sezon', d: 'Planer sezonu → "+ Nowy plan" → rozpisz co posadzisz. Po akceptacji przekształć w zadania.' },
            ].map((s, i) => (
              <li key={i} style={{
                display: 'flex', gap: 18,
                padding: '18px 0',
                borderBottom: '1px solid var(--t-line)',
              }}>
                <div style={{
                  fontFamily: 'var(--t-display)', fontSize: 32,
                  color: 'var(--t-amber)', letterSpacing: '-.04em',
                  lineHeight: 1, fontStyle: 'italic',
                  flexShrink: 0, width: 40,
                }}>{i + 1}</div>
                <div>
                  <Display size={18} style={{ display: 'block', marginBottom: 4 }}>{s.t}</Display>
                  <div style={{ fontSize: 13, color: 'var(--t-text-dim)', lineHeight: 1.55 }}>
                    {s.d}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <Rule label="II — co potrafi aplikacja" />
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 14, marginBottom: 50,
        }}>
          {FEATURES.map(f => (
            <div key={f.title} style={{
              padding: '18px 20px', borderRadius: 12,
              background: 'var(--t-bg-elev)',
              border: '1px solid var(--t-line)',
            }}>
              <Display size={16} style={{ display: 'block', marginBottom: 8 }}>{f.title}</Display>
              <div style={{
                fontSize: 13, color: 'var(--t-text-dim)', lineHeight: 1.5,
              }}>{f.desc}</div>
            </div>
          ))}
        </div>

        <Rule label="III — najczęściej pytane" />
        <div style={{ marginBottom: 50 }}>
          {FAQ.map((item, i) => (
            <FaqItem
              key={i}
              q={item.q}
              a={item.a}
              open={openFaq === i}
              onToggle={() => setOpenFaq(openFaq === i ? -1 : i)}
            />
          ))}
        </div>

        <Rule label="IV — skróty klawiszowe" />
        <div style={{
          padding: '16px 20px', borderRadius: 12,
          background: 'var(--t-bg-elev)',
          border: '1px solid var(--t-line)',
          marginBottom: 50,
        }}>
          {SHORTCUTS.map((s, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '10px 0',
              borderBottom: i < SHORTCUTS.length - 1 ? '1px solid var(--t-line)' : 'none',
            }}>
              <span style={{ fontSize: 13, color: 'var(--t-text-dim)' }}>{s.desc}</span>
              <Chip tone="dim">{s.keys}</Chip>
            </div>
          ))}
        </div>

        <Rule label="V — kontakt" />
        <div style={{
          padding: '20px 22px', borderRadius: 14,
          background: 'var(--t-bg-elev)',
          border: '1px solid var(--t-line)',
          marginBottom: 30,
        }}>
          <Display size={18} style={{ display: 'block', marginBottom: 10 }}>Pomoc / błędy / pomysły</Display>
          <div style={{
            fontSize: 14, color: 'var(--t-text-dim)',
            lineHeight: 1.55, marginBottom: 14,
          }}>
            Aplikacja powstaje w pojedynkę dla społeczności ogrodników. Jeśli coś nie działa,
            chcesz pomysł albo zauważyłeś błąd, daj znać:
          </div>
          <div style={{
            padding: '14px 16px', borderRadius: 10,
            background: 'var(--t-bg)',
            fontFamily: 'var(--t-mono)', fontSize: 13,
            color: 'var(--t-sage)', letterSpacing: '.04em',
          }}>email: hexan@tlen.pl</div>
        </div>

        <div style={{
          marginTop: 60, paddingTop: 20,
          borderTop: '1px solid var(--t-line)',
          display: 'flex', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 14,
          fontFamily: 'var(--t-mono)', fontSize: 11,
          letterSpacing: '.16em', textTransform: 'uppercase',
          color: 'var(--t-text-mute)',
        }}>
          <Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'none' }}>
            Polityka prywatności →
          </Link>
          <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
            ← Strona główna
          </Link>
        </div>
      </div>
    </div>
  );
}
